/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Grid as CustomGrid, MarginHandler } from '../../../styledComponents';
import CustomCard from '../../../components/layout/Card';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { FormControlLabel, Checkbox, FormGroup, FormControl, FormLabel, IconButton, Tooltip, Box, Typography, Button, CardActionArea, CardActions, CircularProgress, Grid } from '@mui/material';
import { colors, fonts } from '../../../utils';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import { setAllSlides } from '../../../redux/slices/slides/slides';
import { errorNotify, successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useLocation, useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import DeleteModal from '../../../components/deletemodal/DeleteModal';

const styles = {
    box: {
        width: "100%",
        marginTop: "2em",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "center"
    },
    slide: {
        width: "200px",
        height: "200px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "2em",
        border: "1px solid lightgrey",
        padding: "10px"

    },
    img: {
        width: "100%",
        margin: "auto"
    },
    Slides: {
        display: "flex",
        alignItems: "center",

    }

};

const Slides = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate()
    const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
    const { primaryFont } = fonts;
    const { colorWhite, colorPrimary, colorGreenGradient } = colors;

    const { slides } = useSelector((state) => state?.slides);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isLoadingImg, setIsLoadingImg] = useState(false);
    const [modalName, setModalName] = useState("");
    const fileInputRef = useRef(null);
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        image: '',
        url: '',
    });



    const handleImageUpload = (event) => {
        setIsLoadingImg(true)
        if (event.target.files.length > 0) {
            let formData = new FormData();
            let file = event.target.files[0];
            let fileName = file.name.replace(/\s/g, '');
            let timestampedFileName = `${new Date().getTime()}_${fileName}`;

            formData.append('file', file, timestampedFileName);
            Api.post(endPoints?.file?.upload, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'xt-user-token': null
                }
            })
                .then((response) => {
                    setIsLoadingImg(false)
                    setFormData((prevState) => ({
                        ...prevState,
                        image: response.data.data.link,
                    }));
                    successNotify("Image Uploaded Successfully")

                })
                .catch((error) => {

                });

        }
    };


    const handleCloseModal = () => {
        setOpenModal(false);
        setIsEditing(false)
    };

    const handleChange = (e) => {

        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));


    };


    const getSlides = async () => {
        try {

            await Api.post(`${endPoints?.slides?.getSlides}`, {
                id: location.state.id,
                is_modal: false,
            }, {
                headers: {
                    'xt-user-token': null
                }
            })
                .then((response) => {
                    dispatch(
                        setAllSlides(
                            response?.data?.data?.slides?.map((d, index) => ({
                                index: index + 1,
                                id: d?.id,
                                slider_id: d?.slider_id,
                                title: d?.title,
                                description: d?.description,
                                url: d?.url,
                                image: d?.image,
                                dt: d?.dt,
                            })
                            ),
                        ),
                    );
                })
                .catch((error) => {
                    
                    // if (error?.response?.status === 400) {
                    // 	errorNotify(error?.response?.data);
                    // 	setDisabledBtn(false);
                    // }
                    // setErrMsg(error?.response?.data?.message || errorMsg);
                });
        } catch (err) {

            // setErrMsg('Login Failed');
            // setDisabledBtn(false);
        }
    };

    const handleDeleteSlide = async () => {

        try {

            await Api.post(endPoints?.slides?.delete, {
                ...formData
            }, {
                headers: {
                    'xt-user-token': null
                }
            })
                .then((response) => {
                    successNotify("Slide Deleted Successfully")
                    handleCloseDeleteModal();
                    getSlides();

                })
                .catch((error) => {

                });

        } catch (err) {

        }
    };
    const handleAddModal = () => {
        setModalName("Add Slide")
        setIsEditing(false);
        setFormData({ title: '', description: '', url: '', image: '' })
        setOpenModal(true)
    };
    const handleEditModal = (val) => {
        setModalName("Edit Slide")
        setIsEditing(true);
        setFormData({ title: val.title, description: val.description, url: val.url, image: val.image, id: val.id })
        setOpenModal(true)
    };


    const handleCloseDeleteModal = () => {
        setFormData({ title: '', description: '', url: '', image: '' })
        setOpenDeleteModal(false)
    };

    const handleDeleteModal = (val) => {
        setFormData({ id: val.id })
        setOpenDeleteModal(true)
    };

    const handleSubmit = async () => {
        if (!isEditing) {


            try {

                await Api.post(endPoints?.slides?.create, {
                    ...formData,
                    slider_id: location.state.id,
                }, {
                    headers: {
                        'xt-user-token': null
                    }
                })
                    .then((response) => {
                        handleCloseModal();
                        getSlides();
                        successNotify("Slides Created Successfully")

                    })
                    .catch((error) => {

                    });

            } catch (err) {

            }

        } else {


            try {

                await Api.post(endPoints?.slides?.update, {
                    ...formData,
                    slider_id: location.state.id,
                }, {
                    headers: {
                        'xt-user-token': null
                    }
                })
                    .then((response) => {
                        handleCloseModal();
                        getSlides();
                        successNotify("Slides Updated Successfully")

                    })
                    .catch((error) => {

                    });

            } catch (err) {

            }
        }
    };

    useEffect(() => {
        getSlides();
    }, [])


    return (
        <>


            <CustomCard margin='3rem 1.5rem' padding='3rem'>
                <Flex jc='space-between' gap='1rem' mb='2rem' fw='wrap'>

                    <ButtonCom btnTitle='Go Back' onClickHandler={() => navigate(-1)} />

                    <ButtonCom onClickHandler={handleAddModal} btnTitle={"Create"} />
                </Flex>
                <Box style={styles.box} >

                    {slides?.map((val) => {

                        return <>

                            <Card sx={{ minWidth: "20em", width: "45%", margin: "1em", maxWidth: "45%" }}>
                                <CardActionArea>
                                    <CardMedia
                                        component="img"
                                        height="140"
                                        image={val.image}
                                        alt="image"
                                    />
                                    <CardContent>
                                        <Grid container spacing={0}>
                                            <Grid item lg={10} md={8} xs={8}>
                                                <Typography className='bold' gutterBottom variant="h5" component="div">
                                                    {val.title}
                                                </Typography>
                                            </Grid>
                                            {/* <Typography variant="body2" color="text.secondary">
                                                {val.description}
                                                </Typography> */}
                                            {/* <CardActions sx={{ display: "flex", justifyContent: "space-evenly" }}> */}
                                            <Grid item lg={1} md={2} xs={2}>
                                                <Button onClick={() => handleDeleteModal(val)} size="small" color="primary">
                                                    <DeleteIcon fontSize='large' color='error' />
                                                </Button>
                                            </Grid>
                                            <Grid item lg={1} md={2} xs={2}>
                                                <Button onClick={() => handleEditModal(val)} size="small" color="primary">
                                                    <EditIcon fontSize='large' />
                                                </Button>
                                            </Grid>
                                            {/* </CardActions> */}
                                        </Grid>
                                    </CardContent>
                                </CardActionArea>
                            </Card>

                            {/* <Box style={styles.box}>
                            <Box>
                            <Typography className='font-face-R' variant="h3">{val.name}</Typography>
                            <Typography className='font-face-R' variant="body1">{val.description}</Typography>
                            </Box>
                            <img  />
                            <Box>
                            
                            <Box>
                                    <Button onClick={() => handleEditModal(val)}  ><EditIcon fontSize='large' /></Button>
                                    <Button onClick={() => handleOpenDeleteModal(val)}  ><DeleteIcon fontSize='large' color='error' /></Button>
                                </Box>
                                <ButtonCom onClickHandler={handleCreateSlidesModal} btnTitle={"Add Slides"} />
                                <ButtonCom onClickHandler={handleCreateSlidesModal} btnTitle={"View Slides"} />
                            </Box>

                        </Box> */}
                        </>
                    })}
                </Box>

                <Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>

                    <TransitionsModal
                        open={openModal}
                        // handleOpen={handleOpenModal}
                        handleClose={handleCloseModal}
                        modalTitle={modalName}
                    >

                        <CustomGrid gtc='repeat(auto-fit, minmax(40rem, 1fr))' margin='2.5rem 0' padding='2rem'>

                            <MarginHandler width='100%'>
                                <InputControl
                                    state={formData?.title}
                                    onChange={handleChange}
                                    label='Title'
                                    name='title'
                                />
                            </MarginHandler>
                            <MarginHandler width='100%'>
                                <InputControl
                                    state={formData?.description}
                                    onChange={handleChange}
                                    label='Description'
                                    name='description'
                                    multiline
                                    rows={1}
                                />
                            </MarginHandler>
                            <MarginHandler width='100%'>
                                <InputControl
                                    state={formData?.url}
                                    onChange={handleChange}
                                    label='Url'
                                    name='url'
                                />
                            </MarginHandler>


                            {isLoadingImg ?
                                <CircularProgress sx={{ margin: "auto" }} color="success" />
                                :
                                <>
                                    <input
                                        // accept="image/*"
                                        accept=".jpeg, .jpg, .png"
                                        style={{ display: 'none' }}
                                        id="image-upload"
                                        type="file"
                                        onChange={(event) => handleImageUpload(event)}
                                    />
                                    <label htmlFor="image-upload">
                                        <Button
                                            variant="contained"
                                            component="span"
                                            color='success'
                                            style={{ width: '99%', marginLeft: '2px', paddingLeft: '2px', fontSize: "1em" }}
                                        >
                                            Upload
                                        </Button>
                                    </label>
                                    {formData?.image &&
                                        <img height={200} style={{ margin: "auto" }} src={formData?.image} />
                                    }
                                </>}



                            <MarginHandler mt="2rem">
                                <Button
                                    color='primary'
                                    variant='contained'
                                    onClick={handleSubmit}
                                    style={{
                                        background: colorGreenGradient,
                                        fontSize: '1.6rem',
                                        textTransform: 'none',
                                        padding: '0.7rem 2rem',
                                        color: colorWhite,
                                        borderRadius: '0.5rem',
                                        float: "right"
                                    }}
                                    disabled={!formData.image || !formData.title}
                                    className='font-face-R'>
                                    {isEditing ? "Update " : "Create "}
                                </Button>
                            </MarginHandler>

                        </CustomGrid>
                    </TransitionsModal>
                </Flex>






                <DeleteModal
                    open={openDeleteModal}
                    handleClose={handleCloseDeleteModal}
                    handleDelete={handleDeleteSlide}
                />








            </CustomCard>
        </>
    );
};

export default Slides;
